module.exports = __webpack_public_path__ + "assets/img/block-3bd6b3a3.png";